function isDarkColor(color) {
    if (!color || typeof color !== "string") return false;

    let r, g, b;

    if (color.startsWith("#")) {
        const hex = color.replace("#", "");
        if (hex.length < 6) return false;
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
    } else if (color.startsWith("rgb")) {
        const result = color.match(/\d+/g);
        if (!result || result.length < 3) return false;
        r = parseInt(result[0]);
        g = parseInt(result[1]);
        b = parseInt(result[2]);
    } else {
        return false;
    }

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128;
}

export default isDarkColor;